/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;

